const riot = require('riot');

riot.tag2('module-provider-google_play_gift_code', '<div class="bg-grad_light_blue w-full h180 pt24"> <div class="text-center ts-hl text-white">特典を受け取る</div> </div> <div class="px24 mtn105"> <div class="w-full pb20 pt38 rounded-8 elevation-default-mid text-center bg-white mb24"> <div class="f fh mb24"><img class="block h130 object-fit-contain" src="/images/google_play_gift_code/logo.png" alt=""></div> <div class="ts-hs text-gray_80 mb4">Google Play ギフトコード</div> <div class="f fc fb"> <div class="fs40 text-gray_80 mr8">{opts.event.amount.toLocaleString(\'ja-JP\')}</div> <div class="ts-hs text-gray_60">円分</div> </div> </div> <div class="mb80" if="{mode === &quot;input_mail&quot;}"> <div class="ts-ps text-gray_80 mb24">特典として Google Play ギフトコードを受け取ることができます。受け取るメールアドレスをご入力ください。</div> <form onsubmit="{toConfirm}"> <input class="input w-full mb24" ref="email" placeholder="メールアドレス" required riot-value="{email}" type="{\'email\'}"> <label class="f fm fit-content cursor-pointer mb26"> <input class="checkbox mr10" type="checkbox" onchange="{onToggleAgree}"> <p class="ts-ps"> <a class="text-link" href="/campaigns/{opts.event.campaign_id}/terms">個人情報の取り扱い</a>に同意しました</p> </label> <button class="button size-l primary w-full mb26" disabled="{!agreeTerms}">確認</button> <p class="text-gray_60 ts-pxs" data-is="atom-anchorify" text="{inputMessage}"></p> </form> </div> <div class="mb40" if="{mode === &quot;confirm_mail&quot;}"> <div class="ts-hs text-gray_80 mb24">メールアドレスのご確認</div> <div class="ts-ps text-gray_80 mb24">こちらのメールアドレスに noreply@incentive.repro.io から<br>Google Play ギフトコードをお送りします。</div> <form onsubmit="{sendMail}"> <input class="input w-full mb24" readonly riot-value="{email}" type="{\'email\'}"> <button class="button size-l primary w-full mb30">メールアドレスを確定</button> </form> <div class="f fh mb30"> <button class="button size-xs text" type="button" onclick="{toInput}">メールアドレスを修正する</button> </div> <p class="text-gray_60 ts-pxs" data-is="atom-anchorify" text="{confirmMessage}"></p> </div> </div>', 'module-provider-google_play_gift_code,[data-is="module-provider-google_play_gift_code"]{display:block}', 'class="w-full"', function(opts) {
    this.inputMessage = 'Google Play は Google LLC の商標です。';
    var confirm_message = `■ Google Play ギフトコードとは
    アプリやゲームをはじめ数百万のアイテムが揃った Google Play なら欲しいものが必ず見つかります。Google Play ギフトコードを手に、無限に楽しめる世界を探検しましょう。人気のゲームや毎日の生活に欠かせないアプリを、手数料なし、有効期限なし、クレジット カードなしで気軽に手に入れることができ、大切な人へのギフトとして最適です。もちろん、自分へのご褒美としても。

    日本の Google Play ストアでのみ使用できます。利用規約が適用されます。
    Google Play ギフトコードは、Android™ の公式アプリストアである Google Play ストアで、アプリやゲームなどの購入に使用できます。

    ■ Google Play ギフトコードの利用規約
    このギフトコードは グーグル・ペイメント合同会社（「GPJ」）が発行するものです。利用規約およびプライバシーポリシーは play.google.com/jp-card-terms をご覧ください。13歳以上の日本の居住者にのみ有効です。ご利用には Google™ ペイメントのアカウントとインターネットアクセスが必要です。利用するには、Play ストア アプリまたは play.google.com でコードを入力してください。このギフトコードのコードは、Google Play および YouTube™ でのみご利用いただけます。コードに関するその他の要求はすべて詐欺の可能性があります。詳しくは、play.google.com/giftcardscam をご覧ください。デバイス、定期購読のご購入には使用できないことがあります。その他の制限が適用される場合があります。手数料や使用期限はありません。法律上必要な場合を除き返金や他のカードとの交換はできません。クレジットアカウントにはチャージできません。カードの金額を補充または返金することはできません。Google Play 以外のアカウントにチャージすることはできません。転売、交換、譲渡することはできません。カードの紛失盗難等についてはお客様の責任となります。残高確認等のお問い合わせは、 support.google.com/googleplay/go/cardhelp、Google Inc.,1600 Amphitheatre Parkway, Mountain View, CA 94043までお願いします。 Google、Android、Google Play、YouTube は Google LLC の商標です。`;

    this.confirmMessage = confirm_message.replace(/^ +/gm, "");

    this.mode = 'input_mail'

    this.preload = async ({req}) => {
      var email = req.query.email;

      return {
        email,
      };
    };

    this.toConfirm = (e) => {
      e.preventDefault();
      this.email = this.refs.email.value;
      this.mode = 'confirm_mail';
      this.update();
    };

    this.toInput = () => {
      this.email = '';
      this.mode = 'input_mail';
      this.update();
    };

    this.sendMail = async (e) => {
      e.preventDefault();
      var indicator = spat.modal.indicator();
      try {
        await app.api.child('ntt_card_solutions/publish').post({ onetime_hash: this.opts.onetimeHash, email: this.email });
        spat.router.push(`/receive?hash=${this.opts.onetimeHash}`);
      }
      catch (e) {
        console.error(e);
        spat.modal.open('modal-error', {statusCode: e.status});
      }
      finally {
        indicator.close();
      }
    };

    this.onToggleAgree = (e) => {
      this.agreeTerms = e.currentTarget.checked;
    };
});